module.exports = __webpack_public_path__ + "img/1-web.0a9b5d27.jpg";